import React, { useState } from "react"
import PropTypes from "prop-types"
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap"
import { ICONS } from "../../constants/icons"
import { formatCityAdminLabel } from "../../helpers/cityPortalRoles"
import useAdminActiveCity from "../../hooks/useAdminActiveCity"

/**
 * City admin header control — badge + dropdown of assigned cities from /me.
 */
const AdminCityDropdown = ({
  iconSrc = ICONS.adminCityLocation,
  label = "Your City",
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const {
    cities,
    activeCity,
    activeCityId,
    activeCityLabel,
    setActiveCityId,
  } = useAdminActiveCity()

  const displayValue = activeCityLabel || "Your City"
  const canSwitch = cities.length > 1

  if (!canSwitch) {
    return (
      <div className="active-city" aria-label={`${label}: ${displayValue}`}>
        <img src={iconSrc} alt="" className="active-city__icon" />
        <span className="active-city__text">
          <span className="active-city__label">{label}</span>
          <span className="active-city__value">{displayValue}</span>
        </span>
      </div>
    )
  }

  const handleSelect = cityId => {
    setActiveCityId(cityId)
    setIsOpen(false)
  }

  return (
    <Dropdown
      isOpen={isOpen}
      toggle={() => setIsOpen(open => !open)}
      className="admin-city-dropdown"
    >
      <DropdownToggle
        tag="button"
        type="button"
        className={`active-city${isOpen ? " active-city--open" : ""}`}
        aria-label={`${label}: ${displayValue}. Change city`}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <img src={iconSrc} alt="" className="active-city__icon" />
        <span className="active-city__text">
          <span className="active-city__label">{label}</span>
          <span className="active-city__value">{displayValue}</span>
        </span>
        <img
          src={ICONS.chevronDown}
          alt=""
          className="active-city__chevron"
          aria-hidden="true"
        />
      </DropdownToggle>
      <DropdownMenu end className="admin-city-dropdown__menu">
        <p className="admin-city-dropdown__heading">Your Cities</p>
        <ul className="admin-city-dropdown__list" role="listbox">
          {cities.map(city => {
            const cityId = String(city.id)
            const isActive = cityId === String(activeCityId || activeCity?.id)
            return (
              <li key={cityId}>
                <button
                  type="button"
                  role="option"
                  aria-selected={isActive}
                  className={`admin-city-dropdown__item${
                    isActive ? " admin-city-dropdown__item--active" : ""
                  }`}
                  onClick={() => handleSelect(cityId)}
                >
                  <img
                    src={iconSrc}
                    alt=""
                    className="admin-city-dropdown__item-icon"
                  />
                  <span className="admin-city-dropdown__item-label">
                    {formatCityAdminLabel(city)}
                  </span>
                  {isActive ? (
                    <span className="admin-city-dropdown__check" aria-hidden="true">
                      ✓
                    </span>
                  ) : null}
                </button>
              </li>
            )
          })}
        </ul>
      </DropdownMenu>
    </Dropdown>
  )
}

AdminCityDropdown.propTypes = {
  iconSrc: PropTypes.string,
  label: PropTypes.string,
}

export default AdminCityDropdown
